import Meta from 'src/components/meta/Meta';

const HowItWorksMeta = () => <Meta
  title="How it Works | Property Investment | BrickX"
  description="BrickX lets you buy portions of properties called Bricks, which store value in step with the market. Get into your home sooner!"
  keywords="Property Investment"
/>;

export default HowItWorksMeta;
